<div
  class="box-drag"
  [class.drag]="dragging"
  (dragover)="$event.preventDefault()"
  (dragenter)="onDragEnter()"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>
  <video
    *ngIf="media && mediaIsVideo()"
    width="100%"
    height="100%"
    autoplay
    loop
    mute
    #videoElm
  >
    <source [attr.src]="media" />
  </video>
  <img
    [attr.src]="media"
    width="100%"
    height="100%"
    *ngIf="media && !mediaIsVideo()"
  />
  <label [hidden]="isUploading()">
    <input
      type="file"
      hidden
      accept="image/*,video/*,.jpg,.jpeg,.exif,.tiff,.tif,.gif,.bmp,.png,.ppm,.pgm,.pbm,.pnm,.webp,.rgbe,
               .heif,.bpg,.ico,.xisf"
      (change)="onInputFileChange($event)"
    />
  </label>

  <div class="centered drag-here" [hidden]="isUploading() || hasMedia()">
    <i inlineSVG="/assets/icons/upload-packshot.svg"></i>
    <p>DRAG HERE</p>
  </div>

  <div class="centered uploading" [hidden]="!isUploading()">
    <img src="/assets/loader3.svg" />
  </div>
</div>
<div class="icon" (click)="playMedia()" *ngIf="hasMedia() && mediaIsVideo()">
  <i inlineSVG="/assets/icons/player-play-small.svg"></i>
</div>
<div class="icon" (click)="deleteMedia()" *ngIf="hasMedia()">
  <i inlineSVG="/assets/icons/pop-trash.svg"></i>
</div>
